import Avatar from './avatar.element.js';

export default Avatar;

Avatar.define('wje-avatar', Avatar);
